import { Suspense } from "react"
import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { SalesFilterForm } from "@/components/sales/filter-form"
import { SalesTable } from "@/components/sales/table"
import { FRONTEND_ROUTES } from "@/constants"

export function SalesPage() {
  const { t } = useTranslation()

  return (
    <Suspense fallback={<div>{t("common.loading")}</div>}>
      <DashboardContainer>
        <Header>
          <AppBreadcrumb
            links={[
              {
                href: FRONTEND_ROUTES.DASHBOARD.href,
                label: t("sidebar.dashboard"),
              },
              {
                label: t("sidebar.sales"),
              },
            ]}
          />
        </Header>
        <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
          <h1 className="page-title">{t("pages.sales.title")}</h1>
          <SalesFilterForm />
          <SalesTable />
        </section>
      </DashboardContainer>
    </Suspense>
  )
}
